/* =============================================================
   Raihan Saffron — theme.js
   Lightweight, no framework. Only DOM the theme actually uses.
   ============================================================= */
(function () {
  'use strict';

  /* ---------- Mobile menu ----------
     2026-10-15 mobile pass (CHR-01 / CHR-11): the menu button toggles; focus moves into the menu on open (the close
     button) and back to the menu button on close; Tab stays inside the open menu; while closed the menu is inert, so
     its 60 links are not in the Tab order. Without JS nothing changes (the menu is only opened by this script). */
  var menuToggle = document.querySelector('.header__menu-toggle');
  var mobileMenu = document.getElementById('MobileMenu');
  var menuClose  = document.querySelector('.mobile-menu__close');
  var menuReturn = null;

  function menuIsOpen() { return !!(mobileMenu && mobileMenu.classList.contains('is-open')); }
  function setInert(on) {
    if (!mobileMenu) return;
    if (on) mobileMenu.setAttribute('inert', ''); else mobileMenu.removeAttribute('inert');
  }
  function menuFocusables() {
    if (!mobileMenu) return [];
    return Array.prototype.filter.call(
      mobileMenu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
  }
  function openMenu() {
    if (!mobileMenu) return;
    menuReturn = document.activeElement;
    setInert(false);
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var first = menuClose || menuFocusables()[0];
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }
  function closeMenu() {
    if (!mobileMenu) return;
    var hadFocus = mobileMenu.contains(document.activeElement);
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setInert(true);
    if (hadFocus) {
      var back = (menuReturn && document.contains(menuReturn) && menuReturn !== document.body) ? menuReturn : menuToggle;
      if (back) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
    }
    menuReturn = null;
  }
  if (mobileMenu && !menuIsOpen()) setInert(true);
  if (menuToggle) menuToggle.addEventListener('click', function () { if (menuIsOpen()) closeMenu(); else openMenu(); });
  if (menuClose)  menuClose.addEventListener('click', closeMenu);
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (e) {
      if (e.target === mobileMenu) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (!menuIsOpen()) return;
      if (e.key === 'Escape') { closeMenu(); return; }
      if (e.key !== 'Tab') return;
      var f = menuFocusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !mobileMenu.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !mobileMenu.contains(a))) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Quantity selectors ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus  = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap  = (minus || plus).closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    var v = parseInt(input.value || '1', 10);
    if (minus) v = Math.max(parseInt(input.min || '1', 10), v - 1);
    if (plus)  v = v + 1;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      var main = btn.closest('.product__gallery').querySelector('.product__media-main img');
      if (main && src) {
        main.src = src;
        main.removeAttribute('srcset');
      }
    });
  });

  /* ---------- Variant selection (no full page reload) ---------- */
  var forms = document.querySelectorAll('.product__form');
  forms.forEach(function (form) {
    var section = form.closest('[data-section-id]');
    if (!section) return;

    function getSelectedOptions() {
      var groups = form.querySelectorAll('.product__option');
      return Array.from(groups).map(function (g) {
        var checked = g.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findMatchingVariant(productData, selected) {
      if (!productData || !productData.variants) return null;
      return productData.variants.find(function (v) {
        return selected.every(function (val, i) {
          if (val == null) return true;
          return v['option' + (i + 1)] === val;
        });
      }) || null;
    }

    function updateUI(variant) {
      if (!variant) return;
      // Hidden variant id
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      // Displayed price + URL stay in sync with the selected variant.
      var fmt = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '.00'); };
      var section = form.closest('.product') || document;
      var priceEl = section.querySelector('.product__price-row .price__regular, .product__price-row .price__sale');
      if (priceEl) {
        var label = priceEl.querySelector('.visually-hidden');
        priceEl.textContent = '';
        if (label) priceEl.appendChild(label);
        priceEl.appendChild(document.createTextNode(' ' + fmt(variant.price)));
      }
      var compareEl = section.querySelector('.product__price-row .price__compare s');
      if (compareEl && variant.compare_at_price) compareEl.textContent = fmt(variant.compare_at_price);
      if (window.history && history.replaceState) {
        try { history.replaceState(null, '', window.location.pathname + '?variant=' + variant.id); } catch (e) {}
      }

      // Notify the subscription UI (and any other listener) that the variant
      // changed, so a stale per-variant selling_plan is never submitted.
      form.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: variant } }));
      // Sticky ATC listens on document with a flat detail shape.
      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { id: variant.id, priceFormatted: fmt(variant.price) } }));

      // Selected value labels
      var groups = form.querySelectorAll('.product__option');
      groups.forEach(function (g, i) {
        var checked = g.querySelector('input[type="radio"]:checked');
        var label = g.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
        // Active swatch state
        g.querySelectorAll('.product__swatch').forEach(function (sw) {
          var inp = sw.querySelector('input');
          sw.classList.toggle('is-active', inp && inp.checked);
        });
      });

      // Submit button availability
      var submit = form.querySelector('button[type="submit"]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (submit.dataset.labelAdd || 'Add to cart') : 'Sold out';
      }
    }

    // Pull product JSON from /products/handle.json once
    var productHandle = window.location.pathname.split('/products/')[1];
    if (productHandle) {
      productHandle = productHandle.split('/')[0].split('?')[0];
      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          form.addEventListener('change', function (e) {
            if (!e.target.matches('.product__option input[type="radio"]')) return;
            var selected = getSelectedOptions();
            var v = findMatchingVariant(data, selected);
            updateUI(v);
          });
        })
        .catch(function () { /* silent */ });
    }
  });

  /* ---------- 2026-10-16 mobile pass round 2 (R2-1): cart drawer footer ----------
     rsx-mobile.css pins the drawer footer to the bottom of the panel (position:sticky) so the subtotal and Check out are
     on screen whenever the panel is taller than the screen. This lets the part under Check out (View full cart, the
     trust lines, the payment icons) sit below the screen edge until the shopper scrolls to the end, so the pinned part
     stays small. Without this script the whole footer is pinned. */
  var cdFoot = document.querySelector('.cdrawer__foot');
  var cdCheckout = cdFoot && cdFoot.querySelector('.cdrawer__checkout');
  if (cdFoot && cdCheckout) {
    var cdTail = function () {
      if (cdFoot.hidden || !cdFoot.offsetHeight) return;
      var tail = Math.floor(cdFoot.getBoundingClientRect().bottom - cdCheckout.getBoundingClientRect().bottom - 16);
      cdFoot.style.setProperty('--rsx-cd-tail', Math.max(0, tail) + 'px');
    };
    if ('ResizeObserver' in window) new ResizeObserver(cdTail).observe(cdFoot);
    window.addEventListener('resize', cdTail, { passive: true });
    cdTail();
  }

  /* ---------- 2026-10-16 mobile pass round 2 (R2-4): wide tables in article and page bodies ----------
     A table that is wider than its scroll box: the box gets .rsx-xs--r / .rsx-xs--l while there are more columns to the
     right / left, so rsx-mobile.css fades that edge and it is clear the box scrolls sideways. A box whose table fits gets
     no class at all. Nothing in the owner's markup or text changes. */
  var xsRoot = document.querySelector('.article__body, .page__content');
  if (xsRoot) {
    var xsBoxes = [];
    Array.prototype.forEach.call(xsRoot.querySelectorAll('table'), function (t) {
      for (var el = t; el; el = el.parentElement) {
        var ox = getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') { if (xsBoxes.indexOf(el) < 0) xsBoxes.push(el); return; }
        if (el === xsRoot) return;
      }
    });
    var xsUpd = function (el) {
      var max = el.scrollWidth - el.clientWidth, x = Math.abs(el.scrollLeft);
      el.classList.toggle('rsx-xs--r', max > 1 && max - x > 1);
      el.classList.toggle('rsx-xs--l', max > 1 && x > 1);
    };
    xsBoxes.forEach(function (el) {
      el.addEventListener('scroll', function () { xsUpd(el); }, { passive: true });
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () { xsUpd(el); });
        ro.observe(el);
        if (el.firstElementChild) ro.observe(el.firstElementChild);
      }
      xsUpd(el);
    });
    if (xsBoxes.length) window.addEventListener('resize', function () { xsBoxes.forEach(xsUpd); }, { passive: true });
  }

  /* Cart-count updates are owned by luxe-ui.js (AJAX drawer). With JS the
     drawer intercepts every /cart/add submit; without it, native submission
     navigates to /cart where the badge re-renders server-side. */
})();
